import { $api } from "../../../../services/request.config";
import { getPeriodsForChildDisability } from "../getPeriodsForChildDisability.action";

export const getPeriodsForChildDisabilityThunkAction = () => async (dispatch) => {
    try {
        const response = await $api("v1/requests/restdays/disabled-child-care/periods");
        if (response.status === 200) {
            dispatch(getPeriodsForChildDisability(response.data));
        }
    } catch (e) {
        dispatch(getPeriodsForChildDisability([]));

    }
}
